import './record-featured-card.scss'

import { faTabletAlt } from '@fortawesome/free-solid-svg-icons';
import { ItemDataStore, itemSelectors, LocationDataStore } from '@skinsoft/entity';
import { RecordFeatured } from '@skinsoft/entity-ui';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { getTranslatedString, Touchable } from '@skinsoft/ui';
import { empty } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { Routes } from '../../../../router';

@Component({
    components: {
        sTouchable: Touchable
    },
    props: ['recordFeatured', 'fromCache'],
    template: require('./record-featured-card.html')
})
export class RecordFeaturedCard extends ReactiveVue {

    public recordFeatured: RecordFeatured;
    public fromCache: boolean;

    private ready: boolean = false;

    private itemLocation: string = "";
    private itemInventoryNumber: string = "";

    private $itemDataStore: ItemDataStore;
    private $locationDataStore: LocationDataStore;

    // Icons
    private localIcon = faTabletAlt;

    private subscribeToItem() {
        const locale = this.$i18n.locale;

        this.$itemDataStore.fetchOne(this.recordFeatured.linkedItemId)
            .pipe(
                switchMap(
                    item => {
                        this.itemInventoryNumber = itemSelectors.identifier(item, locale)
                        const locId = itemSelectors.realTimeLocation(item)
                        if (locId) {
                            return this.$locationDataStore.fetchOne(locId)
                        }
                        this.ready = true;
                        return empty();
                    }
                )
            )
            .subscribe(
                location => {
                    this.itemLocation = getTranslatedString(location.translatedTitle, locale) as string;
                    this.ready = true;
                }
            )
    }

    private openRecord() {
        this.$router.push({ name: Routes.RECORD, params: { campaignId: this.$route.params.campaignId, recordId: this.recordFeatured.id } })
    }

    private get formatCurrentState() {
        // Little hack to avoid diplaying on state key in offline mode
        const fromI18n = this.$t(`state.${this.recordFeatured.currentState}`);
        return fromI18n === `state.${this.recordFeatured.currentState}` ?
            this.recordFeatured.currentState : this.$t(`state.${this.recordFeatured.currentState}`);
    }

    @Watch('recordFeatured', { immediate: true, deep: true })
    private onRecordFeaturedChange() {
        if (this.recordFeatured) {
            this.subscribeToItem();
        }
    }

}